<template>
    <div>
        <span class="me-1">{{ trans('activity.asset.location.changed.label') }}</span>
        <span class="text-muted line-through">{{ oldLabel }}</span>
        <span> → </span>
        <span class="font-semibold">{{ newLabel }}</span>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import { trans } from '@/mixins/i18n.js';

const props = defineProps({ item: { type: Object, required: true } });

const oldLabel = computed(() => props.item.properties?.old?.label || trans('general.not_available'));
const newLabel = computed(() => props.item.properties?.new?.label || trans('general.not_available'));
</script>
